import { useState, useEffect } from "react";
import { CalendarDays } from "lucide-react";

const StickyBookNow = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const heroHeight = document.querySelector("#hero")?.getBoundingClientRect().bottom ?? 0;
      setVisible(heroHeight < 0);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Reserve vertical space at the bottom of the page whenever the sticky bar
  // is visible so it never overlaps the last card / section on mobile.
  // The spacer respects the iOS home-indicator safe area.
  useEffect(() => {
    if (!visible) return;
    const prev = document.body.style.paddingBottom;
    document.body.style.paddingBottom = "calc(5.5rem + env(safe-area-inset-bottom))";
    document.body.dataset.hasStickyBar = "1";
    return () => {
      document.body.style.paddingBottom = prev;
      delete document.body.dataset.hasStickyBar;
    };
  }, [visible]);

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 md:hidden p-4 bg-card/95 backdrop-blur-md border-t border-border animate-fade-in"
      style={{ paddingBottom: "calc(1rem + env(safe-area-inset-bottom))" }}
    >
      <a
        href="#properties"
        onClick={(e) => {
          e.preventDefault();
          document.getElementById("properties")?.scrollIntoView({ behavior: "smooth" });
        }}
        className="flex items-center justify-center gap-2 w-full py-3 rounded-full bg-accent text-accent-foreground font-body font-semibold text-sm shadow-card"
      >
        <CalendarDays className="h-4 w-4" />
        Book Now
      </a>
    </div>
  );
};

export default StickyBookNow;
